import { MenuOutlined } from '@ant-design/icons';
import { Menu, MenuItemProps } from 'antd';
import * as React from 'react';
import styled from 'styled-components';
import { StyledMenu } from './StyledSidebarComponent';

const StyledDiv = styled.div`
  user-select: none;
  .ant-menu-item .anticon,
  .ant-menu-inline-collapsed > .ant-menu-item,
  .ant-menu-vertical > .ant-menu-item {
    font-size: 22px !important;
    font-weight: 500;
    color: #fff;
  }
`;

const StyledSubTitle = styled.div`
  line-height: 18px;
  font-size: 18px;
  margin-left: 42px;
  margin-top: -14px;
`;

interface IStyledMenuItemProps extends MenuItemProps {
  subTitle?: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const StyledMenuItem = styled(({ subTitle, ...props }: IStyledMenuItemProps) => <Menu.Item {...props} />)`
  &&& {
    height: ${(props) => (props.subTitle ? '80' : '60')}px !important;
  }
`;

export interface ISidebarLogoProps {
  title: string;
  subTitle?: string;
  collapsedTitle: string;
  collapsed: boolean;
  onCollapse: () => void;
}

export const SidebarLogo = ({ title, subTitle, collapsedTitle, collapsed, onCollapse }: ISidebarLogoProps) => {
  const [currentTitle, setCurrentTitle] = React.useState(collapsed ? collapsedTitle : title);

  const onClick = () => {
    window.setTimeout(() => {
      setCurrentTitle(!collapsed ? collapsedTitle : title);
    }, 300);
    onCollapse();
  };

  return (
    <StyledDiv>
      <StyledMenu
        theme="dark"
        selectable={false}
        onClick={onClick}
        onKeyDown={(e: React.KeyboardEvent) => e.key === 'Enter' && onClick()}
      >
        <StyledMenuItem tabIndex={0} key="1" subTitle={subTitle}>
          <MenuOutlined />
          <span>{collapsed ? currentTitle : title}</span>
          {currentTitle !== collapsedTitle && subTitle ? <StyledSubTitle>{subTitle}</StyledSubTitle> : null}
        </StyledMenuItem>
      </StyledMenu>
    </StyledDiv>
  );
};
